<template>
  <v-container fluid class="pa-10" style="background-color: #f5f5f5">
    <v-btn
      icon
      class="hidden-xs-only"
      color="primary"
      @click="$router.push('/dashboard')"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-row :gutter="25">
      <v-col cols="6" align="start" class="mb-3">
        Bem-vindo(a) de volta,<br />
        <span class="text-h5 text-center bold"
          >{{ user.firstName }} {{ user.lastName }} ({{
            profilesOptions.find((x) => x.value === user.profileId)
              ? profilesOptions.find((x) => x.value === user.profileId).text
              : ''
          }})</span
        >
      </v-col>
      <v-col cols="6" class="text-end">
        <b>{{
          new Date().toLocaleDateString('pt-Br', { dateStyle: 'full' })
        }}</b>
      </v-col>
      <v-col
        v-if="user.profile.id !== profiles.EDUCANDO"
        lg="3"
        cols="12"
        sm="6"
        md="6"
      >
        <v-hover v-slot="{ hover }">
          <v-card class="orange-card" :elevation="hover ? 15 : 2" outlined>
            <div class="d-flex justify-center text-center pt-6">
              <p class="blueNumbers">{{ totalCoordinators }}</p>
            </div>
            <div class="d-flex justify-center text-center pb-6">
              <p class="description">Coordenadores cadastrados</p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col
        v-if="user.profile.id !== profiles.EDUCANDO"
        lg="3"
        cols="12"
        sm="6"
        md="6"
      >
        <v-hover v-slot="{ hover }">
          <v-card class="orange-card" :elevation="hover ? 16 : 1" outlined>
            <div class="d-flex justify-center text-center pt-6">
              <p class="numbers">{{ totalMonitors }}</p>
            </div>
            <div class="d-flex justify-center text-center pb-6">
              <p class="description">Monitores cadastrados</p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col
        v-if="user.profile.id !== profiles.EDUCANDO"
        lg="3"
        cols="12"
        sm="6"
        md="6"
      >
        <v-hover v-slot="{ hover }">
          <v-card class="orange-card" :elevation="hover ? 15 : 2" outlined>
            <div class="d-flex justify-center text-center pt-6">
              <p class="blueNumbers">{{ totalStudents }}</p>
            </div>
            <div class="d-flex justify-center text-center pb-6">
              <p class="description">Educandos cadastrados</p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
      <v-col
        v-if="user.profile.id !== profiles.EDUCANDO"
        lg="3"
        cols="12"
        sm="6"
        md="6"
      >
        <v-hover v-slot="{ hover }">
          <v-card class="orange-card" :elevation="hover ? 16 : 1" outlined>
            <div class="d-flex justify-center text-center pt-6">
              <p class="numbers">{{ totalOutsides }}</p>
            </div>
            <div class="d-flex justify-center text-center pb-6">
              <p class="description">Usuários externos cadastrados</p>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row
      v-if="
        user.profile.id !== profiles.EDUCANDO &&
        user.profile.id !== profiles.MONITOR_VOLUNTARIO &&
        user.profile.id !== profiles.MONITOR_BOLSISTA
      "
      :gutter="25"
    >
      <v-col lg="6" cols="12" sm="6" md="6">
        <v-card class="second-card orange-card pa-2" outlined>
          <div class="titleCard ml-6 mt-4" style="color: #f3932c">
            ÚLTIMOS LOGINS
          </div>
          <div class="text-overline mb-4 ml-6 mt-2">
            VISUALIZE OS ÚLTIMOS ACESSOS REALIZADOS NO SISTEMA
          </div>
          <div
            v-for="(lastLoginUser, index) in lastLoginUsers"
            :key="index"
            class="text-h7 mb-4 ml-6 mt-2"
          >
            <b>{{ getFullName({ user: lastLoginUser }) }}</b
            >- {{ formatLastLoginDate(lastLoginUser) }}
          </div>
        </v-card>
      </v-col>
      <v-col lg="6" cols="12" sm="6" md="6">
        <v-card class="second-card orange-card pa-2" outlined>
          <div class="titleCard ml-6 mt-4" style="color: #137cc0">HORAS</div>
          <div class="text-overline mb-4 ml-6 mt-2">
            VISUALIZE A QUANTIDADE DE HORAS VINCULADAS AOS USUÁRIOS
          </div>
          <div
            v-for="(topHour, index) in topHours"
            :key="index"
            class="text-h7 mb-4 ml-6 mt-2"
          >
            <b>{{ getFullName(topHour) }}</b
            >- {{ topHour.hours }}h
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row :gutter="25">
      <v-dialog
        v-model="modalAnnouncement"
        :max-width="$vuetify.breakpoint.mdAndDown ? '' : '70vw'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-col v-bind="attrs" lg="4" cols="12" sm="6" md="6" v-on="on">
            <v-card class="second-card orange-card pa-2" outlined>
              <div class="titleCard ml-6 mt-4" style="color: #f3932c">
                COMUNICADOS
              </div>
              <div class="text-overline mb-4 ml-6 mt-2">
                VISUALIZE OS PRÓXIMOS COMUNICADOS
              </div>
              <div
                v-if="announcements.length === 0"
                class="text-h7 mb-2 ml-6 mt-2"
              >
                Não há nenhum comunicado cadastrado.
              </div>
              <div
                v-if="announcements.length > 0"
                class="text-h7 mb-2 ml-6 mt-2"
              >
                <b>{{ announcements[0].title }} </b> -
                {{ announcements[0].date }}
                <div class="text-overline">{{ announcements[0].address }}</div>
              </div>
              <v-divider v-if="announcements.length > 1" />
              <div
                v-if="announcements.length > 1"
                class="text-h7 mb-2 ml-6 mt-2"
              >
                <b>{{ announcements[1].title }} </b> -
                {{ announcements[1].date }}
                <div class="text-overline">{{ announcements[1].address }}</div>
              </div>
              <v-divider v-if="announcements.length > 2" />
              <div
                v-if="announcements.length > 2"
                class="text-h7 mb-2 ml-6 mt-2"
              >
                <b>{{ announcements[2].title }} </b> -
                {{ announcements[2].date }}
                <div class="text-overline">{{ announcements[2].address }}</div>
              </div>
            </v-card>
          </v-col>
        </template>
        <v-card>
          <v-toolbar color="primary" dark>Próximos comunicados</v-toolbar>
          <v-card-text>
            <br />
            <p>
              *Verifique todos os próximos comunicados vinculados ao seu
              usuário.
            </p>

            <v-data-table
              class="mt-12"
              :headers="headersAnnouncements"
              :items="announcements"
            >
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="modalAnnouncement = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="modalEvent"
        :max-width="$vuetify.breakpoint.mdAndDown ? '' : '70vw'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-col v-bind="attrs" lg="4" cols="12" sm="6" md="6" v-on="on">
            <v-card class="second-card orange-card pa-2" outlined>
              <div class="titleCard ml-6 mt-4" style="color: #137cc0">
                EVENTOS
              </div>
              <div class="text-overline mb-4 ml-6 mt-2">
                VISUALIZE OS PRÓXIMOS EVENTOS
              </div>
              <div v-if="events.length === 0" class="text-h7 mb-2 ml-6 mt-2">
                Não há nenhum evento cadastrado.
              </div>
              <div v-if="events.length > 0" class="text-h7 mb-2 ml-6 mt-2">
                <b>{{ events[0].title }} </b> - {{ events[0].date }}
                <div class="text-overline">{{ events[0].address }}</div>
              </div>
              <v-divider v-if="events.length > 1" />
              <div v-if="events.length > 1" class="text-h7 mb-2 ml-6 mt-2">
                <b>{{ events[1].title }} </b> - {{ events[1].date }}
                <div class="text-overline">{{ events[1].address }}</div>
              </div>
              <v-divider v-if="events.length > 2" />
              <div v-if="events.length > 2" class="text-h7 mb-2 ml-6 mt-2">
                <b>{{ events[2].title }} </b> - {{ events[2].date }}
                <div class="text-overline">{{ events[2].address }}</div>
              </div>
            </v-card>
          </v-col>
        </template>
        <v-card>
          <v-toolbar color="primary" dark>Próximos eventos</v-toolbar>
          <v-card-text>
            <br />
            <p>
              *Verifique todos os próximos eventos vinculados ao seu usuário.
            </p>

            <v-data-table
              class="mt-12"
              :headers="headersEvents"
              :items="events"
            >
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="modalEvent = false">
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-col lg="4" cols="12" sm="6" md="6">
        <v-card class="second-card orange-card pa-2" outlined>
          <div class="titleCard ml-6 mt-4" style="color: #f3932c">
            REDES SOCIAIS
          </div>
          <div class="text-overline mb-4 ml-6 mt-2">
            ACESSO RÁPIDO ÀS REDES SOCIAIS
          </div>
          <v-row>
            <v-col
              cols="4"
              class="pointerIcon"
              @click="openUrl('mdi-facebook')"
            >
              <v-img
                alt="Logotipo do Facebook"
                class="shrink"
                contain
                :src="require('@/assets/img/facebook.png')"
                transition="scale-transition"
                height="100"
              />
            </v-col>

            <v-col
              cols="4"
              class="pointerIcon"
              @click="openUrl('mdi-instagram')"
            >
              <v-img
                alt="Logotipo do Instagram"
                class="shrink"
                contain
                :src="require('@/assets/img/instagram.png')"
                transition="scale-transition"
                height="100"
              />
            </v-col>

            <v-col cols="4" class="pointerIcon" @click="openUrl('mdi-youtube')">
              <v-img
                alt="Logotipo do Youtube"
                class="shrink"
                contain
                :src="require('@/assets/img/youtube.png')"
                transition="scale-transition"
                height="100"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { profiles, profilesOptions } from '../utils/Profiles';
// eslint-disable-next-line import/no-cycle
import {
  getTotalUsersCount,
  getUsersTotalActivitiesHours,
  getUsersByLastLogin,
} from '@/services/indicative';
// eslint-disable-next-line import/no-cycle
import { getEventsByCurrentDate } from '@/services/event';
// eslint-disable-next-line import/no-cycle
import { getAnnouncementsByCurrentDate } from '@/services/announcement';

export default {
  data: () => ({
    profiles,
    profilesOptions,
    totalCoordinators: 0,
    totalMonitors: 0,
    totalStudents: 0,
    totalOutsides: 0,
    topHours: [],
    lastLoginUsers: [],
    events: [],
    announcements: [],
    modalAnnouncement: false,
    headersAnnouncements: [
      {
        text: 'Código',
        align: 'start',
        filterable: true,
        value: 'id',
        class: 'primary',
      },
      {
        text: 'Título',
        align: 'start',
        filterable: true,
        value: 'title',
        class: 'primary',
      },
      {
        text: 'Descrição',
        align: 'start',
        filterable: true,
        value: 'description',
        class: 'primary',
      },
      {
        text: 'Data do Comunicado',
        align: 'start',
        filterable: true,
        value: 'date',
        class: 'primary',
      },
    ],
    headersEvents: [
      {
        text: 'Código',
        align: 'start',
        filterable: true,
        value: 'id',
        class: 'primary',
      },
      {
        text: 'Título',
        align: 'start',
        filterable: true,
        value: 'title',
        class: 'primary',
      },
      {
        text: 'Descrição',
        align: 'start',
        filterable: true,
        value: 'description',
        class: 'primary',
      },
      {
        text: 'Endereço',
        align: 'start',
        filterable: true,
        value: 'address',
        class: 'primary',
      },
      {
        text: 'Data do Evento',
        align: 'start',
        filterable: true,
        value: 'date',
        class: 'primary',
      },
    ],
    modalEvent: false,
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  async mounted() {
    if (this.user.profile.id !== this.profiles.EDUCANDO) {
      this.totalCoordinators = (
        await getTotalUsersCount({ type: 'coordinator' })
      ).data;
      this.totalMonitors = (await getTotalUsersCount({ type: 'monitor' })).data;
      this.totalStudents = (await getTotalUsersCount({ type: 'student' })).data;
      this.totalOutsides = (await getTotalUsersCount({ type: 'outside' })).data;
    }

    if (
      this.user.profile.id !== this.profiles.EDUCANDO &&
      this.user.profile.id !== this.profiles.MONITOR_VOLUNTARIO &&
      this.user.profile.id !== this.profiles.MONITOR_BOLSISTA
    ) {
      this.topHours = (await getUsersTotalActivitiesHours()).data;
      this.lastLoginUsers = (await getUsersByLastLogin()).data;
    }

    this.getEvents();
    this.getAnnouncements();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    getFullName({ user }) {
      return `${user.firstName} ${user.lastName}`;
    },
    formatLastLoginDate({ lastLoginAt }) {
      return new Date(lastLoginAt).toLocaleString();
    },
    openUrl(value) {
      switch (value) {
        case 'mdi-facebook':
          window.open('https://www.facebook.com/pejabauru/');
          break;
        case 'mdi-youtube':
          window.open(
            'https://www.youtube.com/channel/UCoKv1pXDZ01-_-KxZ0vfimg'
          );
          break;
        case 'mdi-instagram':
          window.open('https://www.instagram.com/peja_bauru/');
          break;
        default:
          break;
      }
    },
    async getEvents() {
      try {
        this.showLoading();
        const { data } = await getEventsByCurrentDate();

        this.events = data.map((x) => ({
          ...x,
          date: this.formatDateToShow(x.date),
        }));
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar os eventos.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    async getAnnouncements() {
      try {
        this.showLoading();
        const { data } = await getAnnouncementsByCurrentDate();

        this.announcements = data.map((x) => ({
          ...x,
          date: this.formatDateToShow(x.date),
        }));
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar os comunicados.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    formatDateToShow(timestamp) {
      const date = new Date(timestamp);
      const day = date.getUTCDate().toString().padStart(2, '0');
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = date.getUTCFullYear();

      return `${day}/${month}/${year}`;
    },
  },
};
</script>

<style scoped>
.description {
  font-weight: bold;
}

.numbers {
  font-size: 3em;
  color: #f3932c;
  font-weight: bold;
}

.blueNumbers {
  font-size: 3em;
  color: #137cc0;
  font-weight: bold;
}

.orange-card {
  border-radius: 15px;
}

.second-card {
  min-height: 30vh !important;
}

.elevation-1 {
  box-shadow: 0px 1px 1px 0px #f3932c, 0px 1px 3px 0px #f3932c !important;
}

.elevation-16 {
  box-shadow: 0px 5px 30px 0px #f3932c, 0px 16px 60px 0px #f3932c !important;
}

.elevation-2 {
  box-shadow: 0px 1px 1px 0px #137cc0, 0px 1px 3px 0px #137cc0 !important;
}

.elevation-15 {
  box-shadow: 0px 5px 30px 0px #137cc0, 0px 16px 60px 0px #137cc0 !important;
}

.titleCard {
  font-size: 2em;
  font-weight: bold;
}

.bold {
  font-weight: bold;
}

.pointerIcon {
  cursor: pointer;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #137cc0;
  color: white;
}

*
  >>> .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th:hover {
  color: white;
}

* >>> .mdi-arrow-up::before {
  color: white;
}
</style>
